export const isEmptyString = (text?: string, disableTrim = false): boolean => {
    return !text || (disableTrim ? text : text.trim()) === '';
};
